/**
 * User-facing labels for the metamodel editor.
 *
 * Pattern A: this package stays translation-free. Consumers may pass a
 * partial overrides object via `labels`; missing keys fall back to the
 * English defaults declared here.
 */
export type MetamodelEditorLabels = {
  /** Header above the component style preview. */
  stylePreviewHeader: string;
  /** Caption under the style preview header explaining the visualisation. */
  stylePreviewCaption: string;
  /** Alt text for the component style preview image. */
  stylePreviewImageAlt: string;
  /** Placeholder for the new component-type name input. */
  createNodePlaceholder: string;
  /** Fallback message when the create-node validation throws a non-Error. */
  createNodeUnknownError: string;
  /** Validation error: name can't be empty. */
  validationNameEmpty: string;
  /** Validation error: name is already taken. */
  validationNameTaken: string;
  /** Tooltip on the inline add-leaf icon button. */
  addLeafTooltip: string;
  /** Label of the top-level "add component type" button. */
  addRootButton: string;
};

export const DEFAULT_METAMODEL_EDITOR_LABELS: MetamodelEditorLabels = {
  stylePreviewHeader: 'Style Preview',
  stylePreviewCaption:
    'This is how the component type will be displayed. For accessibility and a better experience, the color contrast might be automatically adjusted.',
  stylePreviewImageAlt: "Image preview of the component's style",
  createNodePlaceholder: 'Component type',
  createNodeUnknownError: 'Unknown Error',
  validationNameEmpty: "Name can't be empty",
  validationNameTaken: 'Name is taken',
  addLeafTooltip: 'Add component type',
  addRootButton: 'Add component type',
};

export const mergeMetamodelEditorLabels = (
  overrides?: Partial<MetamodelEditorLabels>
): MetamodelEditorLabels => ({
  ...DEFAULT_METAMODEL_EDITOR_LABELS,
  ...overrides,
});
